import axios from "axios";
// const BACKEND_URL = `http://localhost:8000`;
const BACKEND_URL = `https://nke8a81yme.execute-api.us-east-2.amazonaws.com`;

export const BASE_URL = BACKEND_URL;

export const postDataAPI = async (url, post, token) => {
  const res = await axios.post(`${BASE_URL}/${url}`, post, {
    headers: { Authorization: token },
  });

  return res;
};

export const getDataAPI = async (url, token) => {
  const res = await axios.get(`${BASE_URL}/${url}`, {
    headers: { Authorization: token },
  });

  return res;
};

export const putDataAPI = async (url, post, token) => {
  const res = await axios.put(`${BASE_URL}/${url}`, post, {
    headers: { Authorization: token },
  });

  return res;
};
